import { ApplicationState } from '@/store/application-state';
import { createSelector } from 'reselect';

export const timeSlotsRetrievedSelector = createSelector((state: ApplicationState) => state.general?.timeSlots, x => x);
export const timeSlotsSelector = createSelector((state: ApplicationState) => state.general?.timeSlots?.value, x => x);
